module.exports = __webpack_public_path__ + "img/KuaiShou.0221dd32.png";